<template>
  <div class="d-flex flex-column gap-3 px-4 pb-4">
    <v-alert
      v-for="payment in payments"
      :key="payment.id + '-' + increment"
      color="success"
      class="ma-0 pa-3 py-2 reveal-on-hover black--text"
      text
      dense
    >
      <div class="text-13 d-flex justify-space-between">
        <b>Venda</b> <v-spacer></v-spacer>
        <b class="private-value">{{ payment.amount | currency }}</b>
      </div>
      <div class="text-12 d-flex">
        {{
          paymentUtils.paymentType[payment.paymentType]?.text ||
          payment.paymentType
        }}
        <v-spacer></v-spacer>
        <span>{{ [payment.payedAt] | dateDiff(true) }}</span>
      </div>
    </v-alert>
    <div v-if="!payments.length" class="text-center text-12 grey--text">
      Nenhuma venda realizada ainda.
    </div>
  </div>
</template>
<script>
import VIRTUAL_POS from "../../../services/staff/virtualPos";
import paymentUtils from "@/utils/payment";
export default {
  name: "HistorySideBar",
  data() {
    return {
      payments: [],
      paymentUtils,
      increment: 0,
      interval: null,
    };
  },
  props: {
    token: {
      type: Object,
      required: true,
    },
  },
  methods: {
    addPayment(payment) {
      this.payments.unshift(payment);
    },
    async loadHistory() {
      try {
        const response = await VIRTUAL_POS.getPaymentReport(this.token);
        this.payments = response.payments || [];
      } catch (error) {
        console.error("Error loading payment history:", error);
      }
    },
  },
  mounted() {
    this.$root.$on("payment:confirmed", this.addPayment);
    this.loadHistory();
    this.interval = setInterval(() => {
      this.increment += 1;
    }, 10000);
  },
  beforeDestroy() {
    this.$root.$off("payment:confirmed", this.addPayment);
    clearInterval(this.interval);
  },
};
</script>
